import { useEffect, useState } from "react";
import styles from "./JobPost.module.css";
import useNotification from "../../../hooks/useNotification";
import DashboardServices from "../../../services/DashboardServices";
import React from "react";
import { ENTERPRISE, ENTERPRISE_COMPANY } from "../../../urlConfig";
import CustomBreadcrumb from "../../CommonComponents/CustomBreadcrumb";
import { useLocation } from "react-router-dom";
import JobDetails from "./JobDetails";
import JobDetails2 from "./JobDetails2";
import EnterpriseServices from "../../../services/EnterpriseServices";

const JobPost = () => {
  const { showNotification } = useNotification();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});
  const location = useLocation();

  const BreadcrumbOptions = [
    {
      title: "Enterprise",
      link: ENTERPRISE,
    },
    {
      title: data.company || "Company Name",
      link: ENTERPRISE_COMPANY + location?.pathname?.split("/")?.[3],
    },
    {
      title: data?.JobDescription?.job_title || "job post name",
    },
  ];

  useEffect(() => {
    const fetchUserOverviewData = async () => {
      const res = await EnterpriseServices.getJobById(
        location.pathname.split("/")[5]
      );

      if (res) {
        if (res.statusCode === 1) {
          setData(res.data);
        } else {
          handleError(`${res.statusDesc}`);
        }
      } else {
        handleError(`Error: ${res.statusDesc}`);
      }
      setLoading(false)
    };
    fetchUserOverviewData();
  }, []);

  const handleError = (error) => {
    setLoading(false);
    showNotification(error, "error");
  };

  return (
    <>
      <div className={styles.page_wrap}>
        <CustomBreadcrumb options={BreadcrumbOptions} />
        <JobDetails data={data} loading={loading} />
      </div>
      <div>
        <JobDetails2 data={data} loading={loading} />
      </div>
    </>
  );
};

export default JobPost;
